export const UPDATE_SUBSCRIBER_ID = 'cboard/subscription/UPDATE_SUBSCRIBER_ID';
export const UPDATE_SUBSCRIPTION = 'cboard/subscription/UPDATE_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION_ERROR =
  'cboard/subscription/UPDATE_SUBSCRIPTION_ERROR';
export const SHOW_PREMIUM_REQUIRED =
  'cboard/subscription/SHOW_PREMIUM_REQUIRED';
export const HIDE_PREMIUM_REQUIRED =
  'cboard/subscription/HIDE_PREMIUM_REQUIRED';
export const SHOW_LOGIN_REQUIRED = 'cboard/subscription/SHOW_LOGIN_REQUIRED';
export const HIDE_LOGIN_REQUIRED = 'cboard/subscription/HIDE_LOGIN_REQUIRED';

export const NOT_SUBSCRIBED = 'not_subscribed';
export const PROCCESING = 'proccesing';
export const ACTIVE = 'active';
export const CANCELED = 'canceled';
export const CANCELLED = 'cancelled';
export const IN_GRACE_PERIOD = 'in_grace_period';
export const PAUSED = 'paused';
export const EXPIRED = 'expired';
export const ON_HOLD = 'on_hold';
export const SUSPENDED = 'suspended';
export const UNVERIFIED = 'unverified';

export const DAYS_TO_TRY = 15;

export const REQUIRING_PREMIUM_COUNTRIES = [
  'AE',
  'AT',
  'AU',
  'BE',
  'BH',
  'BM',
  'CA',
  'CH',
  'CL',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GE',
  'GI',
  'GR',
  'HK',
  'HU',
  'IE',
  'IS',
  'IT',
  'JP',
  'KY',
  'LI',
  'LK',
  'LT',
  'LU',
  'MC',
  'NL',
  'NO',
  'NZ',
  'PA',
  'PL',
  'PT',
  'QA',
  'RU',
  'SA',
  'SE',
  'SG',
  'SK',
  'SI',
  'SM',
  'TW',
  'US',
  'VA',
  'ZA'
]; // ISO-2 country codes
